import React from 'react'

export interface IconProps {
    width?: string | number;
    height?: string | number;
    className?: string;
}

export default function AutoshipICon({
    width = 30,
    height = 30,
    className = '',
}: IconProps) {
    return (
        <svg
            version="1.1"
            id="svg9"
            width={width}
            height={height}
            viewBox="0 0 682.66669 682.66669"
            xmlns="http://www.w3.org/2000/svg"
            className={`cursor-pointer group-hover:stroke-white transition duration-200 ${className}`}
        >
            <defs>
                <clipPath clipPathUnits="userSpaceOnUse" id="clipPath23">
                    <path d="M 0,512 H 512 V 0 H 0 Z" />
                </clipPath>
            </defs>
            <g transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)">
                <g clipPath="url(#clipPath23)">
                    <g transform="translate(452,452)">
                        <path
                            d="m 0,0 c 22.091,0 40,-17.909 40,-40 v -352 c 0,-22.091 -17.909,-40 -40,-40 h -392 c -22.091,0 -40,17.909 -40,40 v 352 c 0,22.091 17.909,40 40,40 z"
                            className="stroke-current"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={40}
                        />
                    </g>
                    <path d="M 416,96 H 256 v 160 h 160 z" className="stroke-current" fill="none" stroke="currentColor" strokeWidth={40} />
                    <path d="M 336,256 V 196" className="stroke-current" fill="none" stroke="currentColor" strokeWidth={40} />
                    <path d="M 20,336 H 492" className="stroke-current" fill="none" stroke="currentColor" strokeWidth={40} />
                    <path d="M 96,512 V 392" className="stroke-current" fill="none" stroke="currentColor" strokeWidth={40} />
                    <path d="M 416,512 V 392" className="stroke-current" fill="none" stroke="currentColor" strokeWidth={40} />
                    <path d="M 256,512 V 392" className="stroke-current" fill="none" stroke="currentColor" strokeWidth={40} />
                    <path d="M 136,216 H 176" className="stroke-current" fill="none" stroke="currentColor" strokeWidth={40} />
                    <path d="M 96,136 H 176" className="stroke-current" fill="none" stroke="currentColor" strokeWidth={40} />
                </g>
            </g>
        </svg>
    )
}